import { PageWidget } from 'app/src/shared/components'
import { NavigatePaths } from 'app/src/shared/hooks'

export function Footer() {
  return (
    <>
      <PageWidget containerClassNamesOverrides='bg-[--footer-background]'>
        <div className='flex px-4 py-8 sm:px-6 md:items-center md:justify-between lg:px-8'>
          <div className='mt-8 md:order-1 md:mt-0'>
            <div className='text-base text-white'>
              <div className='text-2xs'></div>
              <div className='mt-1'>
                <div className='mt-2'>
                  <a href='https://www.postewelfareservizi.it/#azienda' target='_blank' rel='noreferrer'>
                    Poste Welfare e Servizi
                  </a>
                </div>
                <div className='mt-4'>
                  <a href={`/#${NavigatePaths.Accessibility}`} target='_blank' rel='noreferrer'>
                    Dichiarazione di Accessibilità
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </PageWidget>
    </>
  )
}
